import { useCallback } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import type { ShareChannel } from 'src/app/pages/psf/promoteOrShare/shared/types';
import { useCurrentUserIdAsync } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

export function useGetPetitionShareUrlSuffix(): (channel: ShareChannel) => string | undefined {
	const currentUserIdState = useCurrentUserIdAsync();
	const currentUserId = isLoaded(currentUserIdState) ? currentUserIdState.value : undefined;

	const {
		data: {
			facebookHeadlineExperiment: { name, variation },
		},
	} = usePsfPromoteOrSharePageData();

	return useCallback(
		(channel: ShareChannel) => {
			if (channel === 'facebook') {
				const isControlVariation = variation.endsWith('control');

				if (isControlVariation) {
					if (currentUserId) {
						return `/fbog/${currentUserId}`;
					}
					return undefined;
				}

				return `/fbogexp/${name}/${variation}`;
			}
			return undefined;
		},
		[currentUserId, name, variation],
	);
}
